"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("../..");
class MenuStateMachine extends __1.FiniteStateMachine {
    constructor() {
        super(...arguments);
        this._state = "start";
    }
    /**
     * Begin Transition
     * [start] -- begin -> [presenting]
     */
    begin() {
        switch (this.state) {
            case "start":
                this.setState("presenting");
                break;
            default: return;
        }
    }
    /**
     * Dismiss Transition
     * [presenting] -- dismiss -> [completed]
     */
    dismiss() {
        switch (this.state) {
            case "presenting":
                this.setState("completed");
                break;
            default: return;
        }
    }
}
exports.default = MenuStateMachine;
//# sourceMappingURL=MenuStateMachine.js.map